module.exports = __webpack_public_path__ + "img/vueLogo.ed419638.png";